import React, { useState } from 'react';
import { FaCog } from 'react-icons/fa';
import '../styles/SettingsButton.css';

const SettingsButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: 'Account Settings', url: '/account-settings' },
    { label: 'Downloads', url: '/downloads' },
    { label: 'Documentation', url: '/blog/7' },
    { label: 'Logout', url: '/logout' },
  ];

  return (
    <div className="settings-container">
      <button 
        className={`settings-button ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaCog className="settings-icon" />
      </button>
      
      {isOpen && (
        <div className="settings-menu">
          {menuItems.map((item, index) => (
            <a 
              key={index}
              href={item.url}
              className="settings-menu-item"
              onClick={(e) => {
                if (item.label === 'Logout') {
                  e.preventDefault();
                  // Add logout logic here
                  window.location.href = '/logout';
                }
              }}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsButton; 